export default (survey) => {
  renderNavigation(survey);
  survey.onCurrentPageChanged.add(() => renderNavigation(survey));
};

function renderNavigation(survey) {
  const ul = document.querySelector("#pageButtonsContainer ul");
  const template = getTemplate();

  if (!ul || !template) return;

  ul.innerHTML = "";
  const fragment = document.createDocumentFragment();

  survey.visiblePages.forEach((page, index) => {
    const li = buildPageButton({ survey, page, index, template });
    fragment.appendChild(li);
  });

  ul.appendChild(fragment);
  updateProgressBar(survey);
}

function getTemplate() {
  const el = document.getElementById("pageButtonTemplate");
  if (!el) {
    console.error('Template element "pageButtonTemplate" not found!');
    return null;
  }
  return el.content;
}

function buildPageButton({ survey, page, index, template }) {
  const clone = document.importNode(template, true);
  const button = clone.querySelector("button");
  const li = clone.querySelector("li");

  setStaticParts(clone, page, index);
  applyStatusClasses(li, getStatus({ survey, page, index }));
  handleClick(button, survey, index);

  return li;
}

function setStaticParts(clone, page, index) {
  clone.querySelector(".page-number").textContent = index + 1;
  clone.querySelector(".page-title").textContent = page.name;
}

function getStatus({ survey, page, index }) {
  const isActive = survey.currentPageNo === index;
  const isPassed = survey.currentPageNo > index;
  const isReview = page.name === "Review";
  const isComplete = !page.hasErrors(false) && !isReview;
  return { isActive, isPassed, isComplete };
}

function applyStatusClasses(li, { isActive, isPassed, isComplete }) {
  li.classList.remove("active", "passed", "completed");

  if (isActive) li.classList.add("active");
  else if (isPassed) {
    li.classList.add("passed", "after:bg-forest-500");
    li.classList.remove("after:bg-gray-200");
  } else if (isComplete) li.classList.add("completed");
}

function handleClick(btn, survey, index) {
  btn.addEventListener("click", () => {
    if (canNavigateTo(survey, index)) survey.currentPageNo = index;
  });
}

function updateProgressBar(survey) {
  const progressBar = document.getElementById("progressBar");
  const innerProgressBar = progressBar?.firstElementChild;
  const labelText = document.getElementById("progressLabel");

  if (!progressBar || !innerProgressBar || !labelText) return;

  const percent = calcCompletionPercent(survey);

  progressBar.setAttribute("aria-valuenow", percent);
  innerProgressBar.style.width = `${percent}%`;
  labelText.textContent = `${percent}%`;
}

function calcCompletionPercent(survey) {
  const reviewIndex = survey.pages.length - 2;
  const pagesToCount = survey.visiblePages.filter((_, index) => index !== reviewIndex);
  const completed = pagesToCount.filter((page) => !page.hasErrors(false)).length;

  return Math.round((completed / pagesToCount.length) * 100);
}

function canNavigateTo(survey, index) {
  const current = survey.currentPageNo;

  if (index < current) return true;

  const previousPageIsValid = !survey.currentPage.hasErrors(true);
  const targetPageCompleted = !survey.pages[index].hasErrors(false);

  // 1. can jump to any earlier passed page
  // 2. can jump forward to a completed page
  // 3. can move to the next page if current page is valid
  return targetPageCompleted || (index === current + 1 && previousPageIsValid);
}
